import { motion } from "framer-motion";
import { Monitor, Bot, Instagram, Search, PenTool, ArrowUpRight } from "lucide-react";
import { SITE } from "@/config/site";
import { SplitWords } from "./Motion";

const icons = { Monitor, Bot, Instagram, Search, PenTool };

const ServiceCard = ({ s, i }) => {
  const Icon = icons[s.icon] || Monitor;
  return (
    <motion.div
      initial={{ opacity: 0, y: 60, rotate: i % 2 ? 2 : -2 }}
      whileInView={{ opacity: 1, y: 0, rotate: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.8, delay: (i % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
      className={i === 0 ? "sm:col-span-2 lg:col-span-1 lg:row-span-2" : ""}
    >
      <a
        href="#contact"
        data-testid={`service-card-${i}`}
        className={`group relative flex h-full min-h-[240px] flex-col justify-between overflow-hidden rounded-[28px] p-7 transition-[transform,box-shadow] duration-500 hover:-translate-y-2 hover:shadow-[0_28px_60px_rgba(15,23,42,0.18)] ${s.dark ? "text-slate-900" : "text-white"}`}
        style={{ background: s.color }}
      >
        <div className="absolute -bottom-10 -right-10 h-40 w-40 rounded-full bg-white/15 transition-transform duration-700 ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[3]" aria-hidden="true" />
        <div className="flex items-start justify-between">
          <span className={`grid h-14 w-14 place-items-center rounded-2xl transition-transform duration-500 group-hover:-rotate-12 group-hover:scale-110 ${s.dark ? "bg-slate-900/10" : "bg-white/20"}`}><Icon className="h-7 w-7" /></span>
          <ArrowUpRight className="h-6 w-6 transition-transform group-hover:rotate-45" />
        </div>
        <div className="relative mt-10">
          <h3 className="font-display text-2xl font-extrabold tracking-tight">{s.name}</h3>
          <p className={`mt-2 text-[15px] leading-relaxed ${s.dark ? "text-slate-900/85" : "text-white/95"}`}>{s.desc}</p>
        </div>
      </a>
    </motion.div>
  );
};

export const Services = () => (
  <section id="services" data-testid="services-section" className="scroll-mt-24 bg-[#FAF9F5] py-20 sm:py-28">
    <div className="container-x">
      <h2 className="max-w-3xl font-display text-4xl font-extrabold tracking-[-0.03em] text-slate-900 sm:text-6xl lg:text-7xl">
        <SplitWords text="What we" /> <SplitWords text="do" delay={0.1} marker="#84CC16" /> <SplitWords text="best." delay={0.15} />
      </h2>
      <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {SITE.services.map((s, i) => <ServiceCard key={s.name} s={s} i={i} />)}
      </div>
    </div>
  </section>
);
